module.exports = __webpack_public_path__ + "img/service-top-bg.58a99d0d.png";